import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {Button} from '@/components/atoms';
import './reviewActionHeader.scss';
import {ROUTES} from '@/utils/constants/routesConstants';

/**
 * ReviewActionHeader
 * Header bar for review screens, similar to the UI in the attached image. Shows a completed date, action buttons, and supports dark mode.
 * @param {Object} props
 * @param {string} props.completedDate - Date string for completed status
 * @param {function} props.onDuplicate - Handler for Duplicate Sales Target
 * @param {function} props.onDownload - Handler for Download
 */
const ReviewActionHeader = ({
  date,
  onDuplicate,
  onDownload,
  isDuplicateEnabled = false,
  showDuplicateButton = true
}) => {
  const handleDuplicate = useCallback(() => {
    onDuplicate(ROUTES.SALES_TARGET_ADD);
  }, [onDuplicate]);

  const handleDownload = useCallback(() => {
    onDownload();
  }, [onDownload]);

  return (
    <div className='review-action-header__container'>
      {date == '' ? (
        <span className='review-action-header__completed'> </span>
      ) : (
        <span className='review-action-header__completed'>{date}</span>
      )}

      <div className='review-action-header__actions'>
        {showDuplicateButton && isDuplicateEnabled && (
          <Button
            handleButton={handleDuplicate}
            uiSchema={{
              className: 'ml-4',
              title: 'Duplicate Sales Target',
              variant: 'secondary',
              size: 'small'
            }}
          />
        )}
        <Button
          handleButton={handleDownload}
          uiSchema={{
            className: 'ml-4',
            title: 'Download',
            variant: 'primary',
            size: 'small',
            disabled: !isDuplicateEnabled
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(ReviewActionHeader);

ReviewActionHeader.propTypes = {
  date: PropTypes.string,
  onDuplicate: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  isDuplicateEnabled: PropTypes.bool,
  showDuplicateButton: PropTypes.bool
};
